import React, { FC, useState } from 'react';

import { CartButton } from 'src/shoppe/elements/CartButton';
import LogIn from 'src/prize/scenes/LogIn';
import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Logo from '../../../../atoms/Logo';
import MobileMenuToggle from '../../../../atoms/MobileMenuToggle';
import Links from './molecules/Links';
import Search from './molecules/Search';

import styles from './index.module.sass';

interface CameronsSeafoodProps {
  links?: INavItem;
  merchant: IMerchant;
}

const CameronsSeafood: FC<CameronsSeafoodProps> = ({ links, merchant }) => {
  const [ overlayLinks, setOverlayLinks ] = useState( false );

  const handleClickMenuToggle = () => {
    setOverlayLinks(( state ) => !state );
  };

  return (
    <div className={styles.header}>
      <div className={styles.mobile}>
        <MobileMenuToggle isActive={overlayLinks} onClick={handleClickMenuToggle} />
      </div>

      <Logo
        className={{ container: styles.logo }}
        image={merchant.logoImageUrl}
        link={merchant.domain}
        name={merchant.name}
      />

      <Search />

      <Links data={links} overlay={overlayLinks} />

      <LogIn className={styles.login} />

      <CartButton className={styles.cartButton} />
    </div>
  );
};
export default CameronsSeafood;
